import { useState } from "react";
import { Copy, Check } from "lucide-react";
import { toast } from "sonner";
import clsx from "clsx";

export function CopyableId({ value, className }: { value: string; className?: string }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async (e: React.MouseEvent) => {
    e.stopPropagation(); // Prevent row clicks in tables
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      toast.success("Copied to clipboard");
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      toast.error("Failed to copy");
    }
  };

  return (
    <button
      onClick={handleCopy}
      className={clsx(
        "group inline-flex items-center gap-1.5 font-mono text-xs font-semibold text-brand-600 hover:text-brand-700 transition-colors bg-brand-50 hover:bg-brand-100 px-2 py-0.5 rounded border border-brand-200/50",
        className
      )}
      title="Click to copy"
    >
      {value}
      {copied ? (
        <Check className="h-3 w-3 text-success-600" />
      ) : (
        <Copy className="h-3 w-3 opacity-0 group-hover:opacity-100 transition-opacity text-brand-500" />
      )}
    </button>
  );
}